<template>
    <div id="service-staff-setting" class="shadow-md rounded-item">
        <vx-card>
            <div class="setting-card-hidden">
                <div class="setting-card-scroll">
                    <h4 class="text-2xl font-bold mb-base">Cash Discount Mode</h4>
                    <!-- <div class="flex align-center">
                        <vs-switch v-model="cash_discount_active" class="my-6" @click.stop="updateCashDiscountMode('switch')"/>
                        <span class="pl-5">A discount amount shall be applied for orders paid in cash</span>
                    </div> -->
                    <div v-if="cash_discount_active">
                        <ul class="centerx flex align-center w-8/12 mb-base">
                            <!-- <li @click="max = 100, input_number_key++">
                                <vs-radio v-model="discount_type" vs-value="percent" class="flex align-center m-0">%</vs-radio>
                            </li>
                            <li @click="max = 99999999999, input_number_key++" class="mr-base">
                                <vs-radio v-model="discount_type" vs-value="value" class="flex align-center m-0">$</vs-radio>
                            </li> -->
                            <p class="mb-0">Cash Discount (%): </p>
                            <!-- <vs-input-number maxlength="3" min="0" :max="max" v-model="discount_value" :key="input_number_key" class="w-6/12"/> -->
                            <vs-input min="0" :max="max" v-model="discount_value" :key="input_number_key" class="w-6/12 ml-6" v-on:keypress="isNumber($event)" disabled></vs-input>
                        </ul>

                        <!-- <div class="flex-center mt-base pt-5">
                            <vs-button style="min-width: 150px;" @click="updateCashDiscountMode('save')">Save</vs-button>
                        </div> -->
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>
<script>
export default {
    name: 'cash-discount-mode',
    data() {
        return {
            cash_discount_active: false,
            loaded_data_num: 0,
            isOpenLoading: false,
            action_type: '',
            discount_type: 'percent',
            discount_value: 0,
            max: 100,
            input_number_key: 0
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get Data";
                    this.openLoadingInDiv();
                }
            }
        },
        discount_type: {
            immediate: true,
            handler() {
                if(this.discount_value > this.max) { 
                    this.discount_value = this.max;
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if (this.loadTime) {
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' Cash Discount Mode Failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);
        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        formatNumber(value) {
            return +(Math.round(value + "e+5") + "e-5");
        },
        isNumber: function(evt) {
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            // if ((charCode > 31 && (charCode < 48 || charCode > 57)) || parseInt(this.discount_value + '' + evt.key) > this.max) {
            if ((charCode > 31 &&  (charCode < 48 || charCode > 57) && charCode !== 46) 
                || (charCode == 46 && this.discount_value.indexOf(".") != -1) 
                || parseFloat(this.discount_value + '' + evt.key) > this.max) {
                evt.preventDefault();
            } else {
                // if(this.discount_value == 0) {
                //     this.discount_value = '';
                // }
                if (charCode == 46) {
                    if(this.discount_value == "") {
                        this.discount_value = 0;
                    }
                } else if (this.discount_value === 0 || this.discount_value === '0') {
                    this.discount_value = "";
                }
                return true;
            }
        },
        updateCashDiscountMode(type) {
            const obj = {
                key: 'config.pos.cash_discount_active',
                value: JSON.stringify({
                    status: type == 'switch' ? (!this.cash_discount_active ? 1 : 0) : (this.cash_discount_active ? 1 : 0),
                    value: (this.discount_value == '' || this.discount_value == null || this.discount_value == undefined) ? 0 : 
                        (this.discount_type == 'percent' ? this.formatNumber(parseFloat(this.discount_value)/100) : this.formatNumber(parseFloat(this.discount_value))),
                    // type: this.discount_type
                    type: 'percent'
                })
            }
            // console.log(obj);
            this.action_type = 'Update';
            this.openLoadingInDiv();
            this.$store.dispatch("appSetting/UPDATE_KEY_STORAGE", obj).then(() => {
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text:'Update Cash Discount Mode Success',
                    color:'success',
                    position:'top-right'})
            })
        }
    },
    created() {
        const obj = {
            key: 'config.pos.cash_discount_active'
        }

        this.$store.dispatch("appSetting/GET_KEY_STORAGE" ,obj).then(() => {
            this.loaded_data_num++;
            let data = this.$store.getters["appSetting/keyStorage"];
            let cash_discount_active = JSON.parse(data.value);
            if(cash_discount_active) {
                this.cash_discount_active = cash_discount_active.status == 1 ? true : false;
                this.discount_type = cash_discount_active.type;
                this.discount_value = this.formatNumber(cash_discount_active.value);
                if(this.discount_type == 'value') {
                    this.max = 99999999999;
                } else {
                    this.discount_value = this.formatNumber(this.discount_value * 100);
                }
            }
        }).catch(() => {
            const obj = {
                key: 'config.pos.cash_discount_active',
                value: JSON.stringify({
                    status: 0,
                    value: 0,
                    type: 'percent'
                })
            }
            this.$store.dispatch("appSetting/ADD_KEY_STORAGE", obj).then(() => {
                this.loaded_data_num++;
            })
        })
    }
}
</script>

